import React from 'react';
import './Home.css';
import Copyright from './Copyright';
import NewsletterGallery from "./NewsletterGallery";
import { useTranslation } from "react-i18next";
import FleetBanner from './FleetBanner';
import { useState } from 'react';
function Home() {
  const { t, i18n } = useTranslation("home"); // <-- récupérer i18n

  return (
<div className="home">
  <section className="hero">
    <video autoPlay loop muted playsInline className="background-video">
      <source src="/video_presentation.mp4" type="video/mp4" />
    </video>

    <div className="hero-content">
     <div className="hero-panel">
    <h1>{t("title")}</h1>
    <p>{t('title2')}</p>
  </div>
    </div>
  </section>
<section className="ea-about">
  <div className="ea-row">
    <div className="ea-left">
      <h1 className="ea-title">{t('title3')}</h1>

      <div className="ea-copy">
        <p>
      {t("welcome")}
        </p>
        <p>
    {t("welcome2")}
        </p>
      </div>
    </div>


    <img className="ea-image"
         src="/Images/home_page.jpg"
         alt="Jet privé Emotions Aero" loading="lazy"/>
  </div>


  <div className="ea-rotator" aria-label="Valeurs Emotions Aero">
    <span>{t("mot_cle_1")}</span>
    <span>{t("mot_cle_2")}</span>
    <span>{t("mot_cle_3")}</span>
  </div>
</section>

<FleetBanner />
  <NewsletterGallery />
  <Copyright />
</div>

  );
}

export default Home;